import React, { useContext } from "react";
import ProjectCardSection from "./ProjectCard";
import { LanguageContext } from "../LanguageContext";

const ProjectsList = () => {
  const [language] = useContext(LanguageContext);

  const projects = [
    {
      id: 1,
      title: language[0].eng === "true" ? "THE SCENT OF MUSIC" : "A ZENE ILLATA",
      description:
        language[0].eng === "true"
          ? "Exploring the deep synergy between music and fragrance. Like musical harmonies, fragrances are composed of top, middle, and base notes that evolve and resonate, enriching perception in subtle and powerful ways."
          : "A zene és az illat közötti mély szinergia felfedezése. Akárcsak a zenei harmóniák, az illatok is felső, közép és alapjegyekből állnak, amelyek fejlődnek és rezonálnak, finom és erőteljes módon gazdagítva az észlelést.",
      image: "https://firebasestorage.googleapis.com/v0/b/noemigyori.appspot.com/o/Images%2Fthescentofmusic.jpeg?alt=media&token=9083047f-6791-4eee-8884-5eaea6ac9d97",
      link: "/projects/thescentofmusic",
    },
  ];

  return (
    <>
      {projects.map((project) => (
        <ProjectCardSection
          key={project.id}
          title={project.title}
          description={project.description}
          image={project.image}
          link={project.link}
        ></ProjectCardSection>
      ))}
      <div style={{ height: "200px" }}></div>
    </>
  );
};

export default ProjectsList;
